import React, { useState, useEffect } from 'react';
import USER_DISPLAY_STRINGS from '../../resources/user_display_strings';
import { useRouteLoadDurationPublisher } from '@amzn/awsscm-argo-core/argo/utils/metrics/ArgoRouteLoadDurationContext';
import { credentialStorage } from '@amzn/awsscm-argo-core/argo/utils/CredentialStorage';
import { Chat } from '@amzn/awsscmui-argo-chatbot-component';
import RecentAppsPane from '../RecentApps';
import { NavigableApplicationsObject } from '../RecentApps/types';
import { get as _get } from 'lodash';
import { getConfigValue } from '../../config/appConfig';
import { useArgoContext } from '@amzn/awsscm-argo-core';
import './index.css';

interface LandingPageProps {
  recentlyUsedLinks: NavigableApplicationsObject[];
  onTogglePinApp?: (app: NavigableApplicationsObject) => void;
  recentAppsLoading: boolean;
  recentAppsError: Error | null;
}

export default function LandingPage({
  recentlyUsedLinks,
  onTogglePinApp,
  recentAppsLoading,
  recentAppsError
}: LandingPageProps) {
  const publishRouteLoadDuration = useRouteLoadDurationPublisher();
  const context = useArgoContext();
  const isExternalUser = credentialStorage.isExternalUser();
  const [showArgoButtonGlow, setShowArgoButtonGlow] = useState(false);

  // Show chat glow for first 3 visits
  useEffect(() => {
    const visitCount = parseInt(localStorage.getItem('askArgoVisitCount') || '0');
    if (visitCount < 3) {
      setShowArgoButtonGlow(true);
      localStorage.setItem('askArgoVisitCount', (visitCount + 1).toString());
    }
  }, []);

  // Remove glow after 15 seconds
  useEffect(() => {
    if (showArgoButtonGlow) {
      const timer = setTimeout(() => setShowArgoButtonGlow(false), 15000);
      return () => clearTimeout(timer);
    }
  }, [showArgoButtonGlow]);

  publishRouteLoadDuration();
  if (getConfigValue('enableRecentApps')) {
    return (
      <div className="asui-grid awsscm-ui">
        <div className="awsui-util-action-stripe-large">
          <div className="awsui-util-action-stripe-title">
            <h1>{USER_DISPLAY_STRINGS.mainTitle}</h1>
            <h3>{USER_DISPLAY_STRINGS.recentAppsHeader}</h3>
            <RecentAppsPane
              recentlyUsedLinks={recentlyUsedLinks}
              onTogglePinApp={onTogglePinApp}
              loading={recentAppsLoading}
              error={recentAppsError}
            />
            {isExternalUser ? null : (
              <div className={showArgoButtonGlow ? 'ask-argo-button-glow' : ''}>
                <Chat context={context} />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="asui-grid awsscm-ui">
      <div className="awsui-util-action-stripe-large">
        <div className="awsui-util-action-stripe-title">
          <h1>{USER_DISPLAY_STRINGS.mainTitle}</h1>
          <p>{USER_DISPLAY_STRINGS.helpText}</p>
          {isExternalUser ? null : (
            <div className={showArgoButtonGlow ? 'ask-argo-button-glow' : ''}>
              <Chat context={context} credentialStorage={credentialStorage} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
